import * as t from 'io-ts'
import { TransactionType } from '../TransactionType'
import { Maybe } from '@mxt/zio/codec'

export const ZaloOther = t.type({
  transactionType: t.literal(TransactionType.ZALO_OTHERS),
  payload: t.type({
    body: t.type({
      message: Maybe(t.string)
    })
  })
})
export type ZaloOther = t.TypeOf<typeof ZaloOther>
